import { MarkdownContent } from '@localagent/ui';
import type { LiveLlmCall } from '@localagent/sdk';

export function StreamingAnswer({ call }: { call: LiveLlmCall }) {
  return (
    <div
      data-testid="streaming-answer"
      data-settled={call.settled ? 'true' : 'false'}
      className="w-full rounded-lg px-4 pt-3 pb-1"
    >
      <MarkdownContent content={call.content} streaming={!call.settled} className="text-chat" />
    </div>
  );
}
